export const SET_ACTIVE_BOOKING = 'modifyBooking/SET_ACTIVE_BOOKING'
export const FETCH_CANCELLATION_DATA = 'modifyBooking/FETCH_CANCELLATION_DATA'
export const RECEIVE_CANCELLATION_DATA =
  'modifyBooking/RECEIVE_CANCELLATION_DATA'
export const CANCELLATION_DATA_ERROR = 'modifyBooking/CANCELLATION_DATA_ERROR'
export const CLEAR_MODIFY_BOOKING = 'modifyBooking/CLEAR_MODIFY_BOOKING'
